import { computed } from "@ember/object"
import { alias, gt } from "@ember/object/computed"
import Service, { inject as service } from "@ember/service"
import _ from "lodash"
import undoAction from "../lib/actions/UNDO_ACTION"

export default class Undo extends Service {
  @service dispatcher

  init() {
    super.init(...arguments)
    this.undos = []
    this.undoCount = 0
  }

  add(action, payload, narrative) {
    if (action.undoPatches && narrative) {
      this.undoCount++
      let undoPatches = action.undoPatches(payload)
      let undoDoc = createUndoDoc(action.id, undoPatches, narrative, this.undoCount)
      this.undos.unshiftObject(undoDoc)
    }
  }

  addWithPatches(actionId, undoPatches, narrative) {
    if (undoPatches !== null && narrative) {
      this.undoCount++
      let undoDoc = createUndoDoc(actionId, undoPatches, narrative, this.undoCount)
      this.undos.unshiftObject(undoDoc)
    }
  }

  @computed("undos.length")
  get nextUndo() {
    return _.last(this.undos)
  }

  @gt("undos.length", 0) hasUndos

  @alias("undos.length")
  nextUndoNumber

  pop() {
    let undo = this.undos.shiftObject()
    this.dispatcher.dispatchPreparedAction(
      undoAction({
        patches: undo.attributes.patches,
        originalActionId: undo.attributes.originalActionId,
        originalActionNarrative: _.pick(undo.attributes, [
          "title",
          "titleForAnalytics",
          "description",
          "context",
          "activity",
          "newAnalyticsEvents",
        ]),
      })
    )
  }
}

function createUndoDoc(id, undoPatches, narrative, undoSequenceNumber) {
  return {
    id: id,
    type: "undo",
    attributes: {
      title: narrative.title,
      titleForAnalytics: narrative.titleForAnalytics,
      description: narrative.description,
      context: narrative.context,
      activity: narrative.activity,
      originalActionId: id,
      sequenceNumber: undoSequenceNumber,
      patches: undoPatches,
    },
  }
}
